module.exports = __webpack_public_path__ + "static/icon-02.1ebd8bd0.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-02.png
// module id = 1011
// module chunks = 2